import get from 'lodash/get';
export default function isUnauthorizedResponse(apiError) {
    return (get(apiError, 'response.status') || apiError.statusCode) === 401;
}
